import { baseCompareVersion } from '@didi/webx-js-core';
/* important!! 不要修改下方version的格式 如需修改 请确认build/update-version.js运行正常 */
/* version */
export const version = '2.7.14';
/* End version */
export const getVersion = () => {
    return version;
};
export const compareVersion = (preVersion = '', lastVersion = version) => {
    return baseCompareVersion(preVersion, lastVersion);
};
